import { observationsSchema } from "@/schemas/observation-schema";
import { IFetchObservationResult } from "@/types/observation-type";

export const fetchObservation = async (): Promise<IFetchObservationResult> => {
	const requests = Array.from({ length: 12 }, async (_, i) => {
		const date = new Date();
		date.setHours(date.getHours() - (11 - i));

		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const hours = String(date.getHours()).padStart(2, "0");

		const response = await fetch(
			`https://kuwait.exelys.io/kuwait_stations_observation/kuwait_observation_${year}-${month}-${day}T${hours}:00:00+03:00.json`,
		);

		if (!response.ok) {
			throw new Error(`HTTP ${response.status}`);
		}

		const observationData = await response.json();
		const validObservationData = observationsSchema.parse(observationData);

		return validObservationData.map((observation) => ({
			station_id: observation.station_id,
			data: {
				...observation.data,
				date,
			},
		}));
	});

	const results = await Promise.allSettled(requests);

	const stationData = results.map((result) =>
		result.status === "fulfilled" ? result.value : [],
	);

	return {
		isLoading: false,
		error: null,
		stationData,
	};
};
